import React from 'react';
import algoliasearch from 'algoliasearch/lite';
import { Row, Card, Col } from 'react-bootstrap';
import LazyLoad from 'react-lazyload';
import { Configure, InstantSearch, connectInfiniteHits } from 'react-instantsearch-dom';
import moment from 'moment';
import { Trans } from 'react-i18next';

const indexName = "prod_OSRAM_COM_en";
const searchClient = algoliasearch(
    '9PS0M7DUIE',
    '321a182fe8706b78ee3234b41c7b58f7'
);

export default class ProductNews extends React.Component {
    render() {

        if ( this.props.brandName === 'BRAND_PG' || this.props.brandName === 'BRAND_TCI' ) { return null; }

        const CustomInfiniteHits = connectInfiniteHits(InfiniteHits);

        return (
            <Card className="card-recent-projects">
                <div className='card-header-recent-project'>
                    <h6 style={{ marginBottom: '0' }}><Trans i18nKey="Products_News" /></h6>
                </div>
                <Card.Body style={{ padding: '1rem', overflowY: 'auto' }}>
                    <InstantSearch indexName={indexName} searchClient={searchClient} >
                        <Configure
                            hitsPerPage={25}
                            filters="content_type_keyword:News AND bu_multi_keyword:'Digital Systems'"
                            maxValuesPerFacet={200}
                            distinct
                        />
                        <CustomInfiniteHits />
                    </InstantSearch>
                </Card.Body>
            </Card>
        );
    }
};

const InfiniteHits = ({
    hits,
    hasPrevious,
    refinePrevious,
    hasMore,
    refineNext,
}) => {

    let cont = -1;

    return hits.map(hit => {

        cont++;

        return (
            <Col key={hit.objectID} style={{ padding: "0" }}>
                {cont === 0 && !hasPrevious ? null : <hr />}
                <Row style={{ marginBottom: "0.5rem" }}>
                    <Col sm="3" style={{ textAlign: "center", margin: "auto 0" }}>
                        {moment(hit.dp_date * 1000).format('DD/MM/YYYY')}
                    </Col>
                    <Col sm="9">
                        <b>{hit.title}</b>
                    </Col>
                </Row>
                <Row>
                    <Col sm="3">
                        <LazyLoad
                            className="app thumb-placeholder"
                            once={true}
                            overflow={true}
                            offset={[0, 300]}
                            placeholder={<i className="ui centered icon camera" />}>
                            <img className="app thumb-image"
                                style={{ maxWidth: '100%', maxHeight: '8rem' }}
                                src={hit.src1_picture_stored_only}
                                alt={hit.title} />
                        </LazyLoad>
                    </Col>
                    <Col sm="9">
                        <div className="hit-description" style={{ height: '8rem', overflow: 'hidden' }}>
                            {hit.content}
                        </div>
                        <a href={hit.link} target="_blank" rel="noopener noreferrer" className="datasheet"><Trans i18nKey="Read_more" /></a>
                    </Col>
                </Row>
            </Col>
        );
    });
}
